import View from './view';

export const NotificationsAndUser = View;
